// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-project-js": () => import("/home/simon/simse.io/src/templates/project.js" /* webpackChunkName: "component---src-templates-project-js" */),
  "component---src-templates-blog-js": () => import("/home/simon/simse.io/src/templates/blog.js" /* webpackChunkName: "component---src-templates-blog-js" */),
  "component---src-pages-404-js": () => import("/home/simon/simse.io/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-api-js": () => import("/home/simon/simse.io/src/pages/api.js" /* webpackChunkName: "component---src-pages-api-js" */),
  "component---src-pages-blog-js": () => import("/home/simon/simse.io/src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */),
  "component---src-pages-index-js": () => import("/home/simon/simse.io/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-labs-js": () => import("/home/simon/simse.io/src/pages/labs.js" /* webpackChunkName: "component---src-pages-labs-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/home/simon/simse.io/.cache/data.json")

